module.exports = __webpack_public_path__ + "img/ic_manual_install.6c5fd89.svg";